import React, { FC } from 'react';
import { PublicJobDetailLayout } from './components/PublicJobDetailLayout/PublicJobDetailLayout';
import { PublicJobDetailCard } from 'modules/publicJob/detail/components/PublicJobDetailCard';
import { PublicJobDetailSidebar } from 'modules/publicJob/detail/components/PublicJobDetailSidebar';
import { PublicJobDetailSimilarJobs } from '../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailSimilarJobs';
import { usePublicJobDetailDataQuery } from '../../../../../ReactSharedScripts/modules/publicJob/detail/hooks';
import { isNull } from '../../../../../ReactSharedScripts/predicates/type';
import { PublicJobDetailBackButton } from '../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailBackButton';

export const PublicJobDetail: FC = () => {
	const {
		data: { similarJobs },
	} = usePublicJobDetailDataQuery();
	return (
		<PublicJobDetailLayout>
			<PublicJobDetailLayout.TopSection>
				<PublicJobDetailBackButton />
			</PublicJobDetailLayout.TopSection>
			<PublicJobDetailLayout.Main>
				<PublicJobDetailCard />
			</PublicJobDetailLayout.Main>
			<PublicJobDetailLayout.Aside>
				<PublicJobDetailSidebar />
			</PublicJobDetailLayout.Aside>
			{!isNull(similarJobs) && (
				<PublicJobDetailLayout.BottomSection>
					<PublicJobDetailSimilarJobs />
				</PublicJobDetailLayout.BottomSection>
			)}
		</PublicJobDetailLayout>
	);
};
